import { getLocale } from "../runtime";

const sv_notfoundsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi kan inte hitta sidan du letar efter.`
};

const notfoundsubtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notfoundsubtitle(inputs)
	return "notFoundSubtitle";
};

export { notfoundsubtitle as "notFoundSubtitle" };